module.exports = __webpack_public_path__ + "static/media/good.eaf88cad.gif";